
















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import settings from '@/settings.json';
import notificationService from '@/services/notificationService';
import { DxTabs } from 'devextreme-vue';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';
import MeasuringStateBlockCard from '@/modules/measuringstates/components/measuringstateBlockCard.vue';
import MeasuringStateDocument from '@/modules/measuringstates/components/MeasuringStateDocument.vue';
import MeasuringStateRating from '@/modules/measuringstates/components/MeasuringStateRating.vue';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';

import {
  MeasuringStatesClient,
  MeasuringState,
  QuotationsClient,
  UpdateMeasuringStateCommand,
  SplitMeasuringStateCommand,
  ContractsClient,
  CreateContractFromMeasuringStateCommand,
  ContactsClient,
  ContactsLookupQuery,
  DataSourceLoadOptionsBase,
  QuotationBasicListItemDto,
  MeasuringStateRawMaterialUsageDto,
  MeasuringStateRatingItemInfoDto,
  MeasuringStatesRatingClient,
  CreateMeasuringStateRatingCommand,
  UpdateMeasuringStateRatingCommand,
  DeleteMeasuringStateRatingCommand,
  UpdateMeasuringStateTypeCommand,
  MeasuringStateDto,
  ContractListItemDto,
} from '@/data/web-api-client';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import MeasuringStateApprovedPopup from '../components/popups/MeasuringStateApprovedPopup.vue';
import DxTooltip from 'devextreme-vue/tooltip';
import { DxItem } from 'devextreme-vue/tabs';
import CreateSettlementPopup from '@/modules/projects/measuringStates/components/CreateSettlementPopup.vue';
import MarkMeasuringStateLinesCompletedDialog from '../components/popups/MarkMeasuringStateLinesCompletedDialog.vue';
import moment from 'moment';
import MarkMeasuringStateQualityCheckedDialog from '../components/popups/MarkMeasuringStateQualityCheckedDialog.vue';

@Component({
  components: {
    EventLogsTable,
    Card,
    Datagrid,
    MeasuringStateBlockCard,
    DxTabs,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    MeasuringStateDocument,
    MeasuringStateRating,
    MeasuringStateApprovedPopup,
    DxTooltip,
    DxItem,
    CreateSettlementPopup,
    MarkMeasuringStateLinesCompletedDialog,
    MarkMeasuringStateQualityCheckedDialog,
  },
})
export default class MeasuringStatePage extends Vue {
  loading: boolean = true;
  navIndex: number = 0;
  measuringState: MeasuringStateDto | null = null;
  dirty: boolean = false;
  loadingRawmaterials: boolean = true;
  saving: boolean = false;
  rawmaterials: MeasuringStateRawMaterialUsageDto[] = [];
  measuringStateRating: MeasuringStateRatingItemInfoDto | null = null;
  leftPositionBottomBar: number = 0;
  ratingChanged: boolean = false;
  disabled = false;
  projectContracts: ContractListItemDto[] = [];
  monthForm = {
    selectedMonth: null,
  };
  selectedMonth: moment.Moment | undefined;
  uniqueMonths: any[] = [];
  qualityCheckMonths: any[] = [];

  quotations: QuotationBasicListItemDto[] = [];
  measuringStatesClient = new MeasuringStatesClient(undefined, this.$axios);
  measuringStateRatingsClient = new MeasuringStatesRatingClient(undefined, this.$axios);
  contractsClient = new ContractsClient(undefined, this.$axios);
  subContractorValueChanged: boolean = false;

  draftMeasuringState: string = 'Klad';

  async created() {
    await this.loadData();
  }

  mounted() {
    this.setNav();

    if (document) {
      const bar = document.getElementById('savebar');

      if (bar) {
        const rect = bar.getBoundingClientRect();
        this.leftPositionBottomBar -= rect.left;
      }
    }
  }

  async loadData() {
    try {
      this.loading = true;
      await this.loadMeasuringState();
      const emptyArray: moment.Moment[] = [];

      if (this.measuringState?.allLines) {
        const uniqueMonths = this.measuringState?.allLines
          .filter((l) => !!l.monthExecuted)
          .reduce((acc, item) => {
            const momentDate = moment(item.monthExecuted!).date(15);

            if (!acc.some((date) => date.format('YYYY-MM-DD') === momentDate.format('YYYY-MM-DD'))) {
              acc.push(momentDate);
            }
            return acc;
          }, emptyArray);

        this.uniqueMonths = uniqueMonths.map((d) => ({
          value: d,
          text: d.locale('nl-BE').format('MMMM yyyy'),
        }));
      }
      this.disabled = this.measuringState!.projectIsOnHold!;

      this.loadQuotations();
      this.loadRawMaterials();
      this.loadMeasuringStateRating();
      this.loadContracts();
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  async loadQuotations() {
    if (this.measuringState) {
      this.quotations = await new QuotationsClient(undefined, this.$axios).getList(this.measuringState!.projectId!, null);
    }
  }

  async loadRawMaterials() {
    if (this.measuringState) {
      this.loadingRawmaterials = true;
      this.rawmaterials = await this.measuringStatesClient.getRawMaterials(this.measuringState!.projectId!, this.$route.params.name);

      setTimeout(() => {
        this.loadingRawmaterials = false;
      }, 250);
    } else {
      this.loadingRawmaterials = false;
    }
  }

  async loadContracts() {
    if (this.measuringState?.projectId) {
      this.projectContracts = await this.contractsClient.get(this.measuringState.projectId);
    }
  }

  async loadMeasuringStateRating() {
    if (this.measuringState && this.measuringStateRating && this.measuringState.subcontractorId != this.measuringStateRating.subcontractorId) {
      await this.measuringStateRatingsClient
        .delete(
          new DeleteMeasuringStateRatingCommand({
            id: this.measuringStateRating.id,
          })
        )
        .then(() => {
          this.measuringState!.measuringStateRatingId = undefined;
          this.measuringStateRating = null;
        });
    }
    if (this.measuringState && this.measuringState.measuringStateRatingId && this.measuringState.subcontractorId) {
      this.measuringStateRating = await this.measuringStateRatingsClient.getSingle(this.$route.params.name, this.measuringState.subcontractorId);
    }
    if (!this.measuringStateRating && this.measuringState && this.measuringState.subcontractorId) {
      this.measuringStateRating = await this.measuringStateRatingsClient.create(
        new CreateMeasuringStateRatingCommand({
          cleanliness: 0,
          quality: 0,
          punctuality: 0,
          fulfillingAgreements: 0,
          measuringStateId: this.measuringState!.documentNumber,
          subcontractorId: this.measuringState!.subcontractorId,
        })
      );
      this.measuringState!.measuringStateRatingId = this.measuringStateRating!.id;
      this.save();
    }
  }

  async save() {
    try {
      this.saving = true;
      if (this.measuringState) {
        await this.measuringStatesClient.update(new UpdateMeasuringStateCommand(this.measuringState));
      }
      this.dirty = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
      if (this.subContractorValueChanged) {
        this.loadMeasuringStateRating();
      }
    }
  }

  async openApproveDialog() {
    (this.$refs.MeasuringStateApprovedPopup as MeasuringStateApprovedPopup).open();
  }

  async approveMeasuringState(isApproved: boolean) {
    if (isApproved && this.measuringState != null) {
      this.measuringStatesClient
        .updateMeasuringStateType(
          new UpdateMeasuringStateTypeCommand({
            documentNumber: this.measuringState.documentNumber,
            measuringStateType: 'Goedgekeurd',
          })
        )
        .then(() => {
          this.loadData();
        });
    }
  }

  async saveMeasuringStateRating() {
    try {
      if (this.measuringStateRating) {
        await this.measuringStateRatingsClient.update(this.measuringStateRating.id, new UpdateMeasuringStateRatingCommand(this.measuringStateRating));
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.ratingChanged = false;
    }
  }

  async split() {
    if (confirm(this.$t('messages.AreYouSure') as string)) {
      if (this.dirty) {
        await this.save();
      }
      try {
        this.saving = true;
        if (this.measuringState) {
          await this.measuringStatesClient.split(new SplitMeasuringStateCommand(this.measuringState));
        }
        this.loadData();
        notificationService.saved();
      } catch (err) {
        notificationService.failedToSave();
      } finally {
        this.saving = false;
      }
    }
  }

  async generateContract() {
    if (!this.measuringState || !this.measuringState.subcontractorId) {
      alert('Er is geen onderaannemer geselecteerd!');
      return;
    }

    if (confirm('Wenst u een contract te maken?')) {
      try {
        this.saving = true;
        const contractResult = await new ContractsClient(undefined, this.$axios).create(
          new CreateContractFromMeasuringStateCommand({
            projectId: this.measuringState.projectId!,
            measuringStateRef: this.measuringState.documentNumber!,
            subcontractorId: this.measuringState.subcontractorId!,
          })
        );
        notificationService.saved();
        this.$router.push({
          path: `/contracts/${contractResult.replace('/', '-').replace('/', '-')}`,
        });
      } catch (err) {
        notificationService.failedToSave();
      } finally {
        this.saving = false;
      }
    }
  }

  async markComplete() {
    if (confirm('Dit markeren als uitgevoerd?')) {
      if (this.dirty) {
        await this.save();
      }
      try {
        this.saving = true;
        if (this.measuringState?.blocks) {
          // set completed
          this.measuringState.blocks.forEach((block) => {
            if (block.selected) {
              block.lines!.forEach((line) => {
                line.completed = true;
              });
            } else {
              if (block.lines) {
                block.lines.forEach((line) => {
                  if (line.selected) {
                    line.completed = true;
                  }
                });
              }
            }
          });
          await this.measuringStatesClient.update(this.measuringState);
        }
        this.loadData();
        notificationService.saved();
      } catch (err) {
        notificationService.failedToSave();
      } finally {
        this.saving = false;
      }
    }
  }

  async markUnComplete() {
    if (confirm('Deze uitvoering ongedaan maken?')) {
      if (this.dirty) {
        await this.save();
      }
      try {
        this.saving = true;
        if (this.measuringState?.blocks) {
          // set completed
          this.measuringState.blocks.forEach((block) => {
            if (block.selected) {
              block.lines!.forEach((line) => {
                line.completed = false;
              });
            } else {
              if (block.lines) {
                block.lines.forEach((line) => {
                  if (line.selected) {
                    line.completed = false;
                  }
                });
              }
            }
          });
          await this.measuringStatesClient.update(this.measuringState);
        }
        this.loadData();
        notificationService.saved();
      } catch (err) {
        notificationService.failedToSave();
      } finally {
        this.saving = false;
      }
    }
  }

  setNav() {
    setTimeout(() => {
      if (this.$route.query.navIndex) {
        if (!isNaN(this.$route.query.navIndex as any)) {
          this.navIndex = parseInt(this.$route.query.navIndex as any, 11);
        } else {
          this.navIndex = 0;
        }
      } else {
        this.navIndex = 0;
      }
    }, 300);
  }

  showTooltip(tooltipRef: string) {
    if (!this.$refs[tooltipRef]) return;

    (this.$refs[tooltipRef] as any[])[0].instance.show();
  }

  hideTooltip(tooltipRef: string) {
    if (!this.$refs[tooltipRef]) return;
    (this.$refs[tooltipRef] as any[])[0].instance.hide();
  }

  createSettlement() {
    if (!this.measuringState) {
      return;
    }

    try {
      (this.$refs.CreateSettlementPopup as CreateSettlementPopup).open({
        selectedMeasuringStates: [this.measuringState.documentNumber!],
        projectId: this.measuringState?.projectId ?? '',
        contractNumber: '',
      });
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async loadMeasuringState(monthExecuted?: moment.Moment) {
    this.measuringState = await this.measuringStatesClient.getSingle(this.$route.params.name, monthExecuted?.toDate());

    const monthsArray: moment.Moment[] = [moment().date(15)];

    if (this.allowPreviousMonthCompletion) {
      monthsArray.push(moment().subtract(1, 'months').date(15));
    }

    this.qualityCheckMonths = monthsArray.map((d) => ({
      value: d,
      text: d.locale('nl-BE').format('MMMM yyyy'),
    }));
    this.disabled = this.measuringState!.projectIsOnHold!;
  }

  async openExecutionDateDialog() {
    (this.$refs.MarkMeasuringStateLinesCompletedDialog as MarkMeasuringStateLinesCompletedDialog).open();
  }

  async saveExecutedDate(monthExecuted: Date) {
    if (!monthExecuted) {
      return;
    }

    try {
      this.saving = true;

      if (this.measuringState && this.measuringState.blocks) {
        this.measuringState.blocks.forEach((block) => {
          if (block.selected) {
            block.lines!.forEach((line) => {
              line.completed = true;
            });
          } else {
            if (block.lines) {
              block.lines.forEach((line) => {
                if (line.selected) {
                  line.completed = true;
                }
              });
            }
          }
        });

        const updateCommand = new UpdateMeasuringStateCommand(this.measuringState);

        updateCommand.monthExecuted = monthExecuted;

        await this.measuringStatesClient.update(updateCommand);
      }

      this.loadData();
      notificationService.saved();
    } catch (err) {
      notificationService.failedToSave();
    } finally {
      this.dirty = false;
      this.saving = false;
    }
  }

  async setQualityChecked() {
    this.showQualityCheckDialog();
  }

  showQualityCheckDialog() {
    (this.$refs.MarkMeasuringStateQualityCheckedDialog as MarkMeasuringStateQualityCheckedDialog).open();
  }

  async saveQualityCheck(dates: moment.Moment[]) {
    const documentNumber = this.measuringState?.documentNumber?.replaceAll('/', '-');
    const latestDate = moment.max(dates);

    await this.measuringStatesClient.setQualityChecked(documentNumber!, latestDate.toDate());
    await this.loadMeasuringState(this.selectedMonth);
  }

  get allowPreviousMonthCompletion(): boolean {
    if (!this.measuringState || !this.measuringState.allLines) {
      return false;
    }
    const startOfPreviousMonth = moment().subtract(1, 'months').date(1).startOf('date');
    const relevantQualityCheckedLines = this.measuringState.allLines.filter((l) => l.qualityCheckMonth);

    // if there are qualitychecked lines in previous or current month and are invoiced to sucontractor or in progressstatement return false
    // not allowed to execute in previous montyh anymore
    return !relevantQualityCheckedLines.some((qcl) => moment(qcl.qualityCheckMonth) >= startOfPreviousMonth && (qcl.includedInProgressState || qcl.invoicedSubcontractor));
  }

  get documentUrl() {
    return settings.api + '/document/' + this.$route.params.name;
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Inhoud', disabled: false, hint: '' },
      { icon: 'fas fa-toolbox', text: 'Grondstoffen', disabled: false, hint: '' },
      { icon: 'fas fa-star', text: 'Beoordeling', disabled: false, hint: '' },
      { icon: 'fas fa-file-pdf', text: 'Document', disabled: false, hint: '' },
      { icon: 'fas fa-history', text: 'Geschiedenis', disabled: false, hint: '' },
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectName: this.measuringState ? this.measuringState.documentNumber! : '',
      type: EventLogsObjectType.MeasuringState,
    };
  }

  get subcontractorOptions() {
    const client = new ContactsClient(undefined, this.$axios);
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (loadOptions.filter) {
              loadOptions.filter = undefined;
            }
            if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
              loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
            }

            const res = await client.lookupContacts(
              new ContactsLookupQuery({
                projectId: this.measuringState ? this.measuringState.projectId : undefined,
                type: 'Subcontractor',
                options: new DataSourceLoadOptionsBase(
                  Object.assign({}, loadOptions, {
                    stringToLower: true,
                  })
                ),
              })
            );

            return res;
          },
          byKey: async (val: string) => {
            return await client.getBasicInfo(val);
          },
        }),
        paginate: false,
      }),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
      disabled: false,
      showClearButton: true,
      onValueChanged: (e: any) => {
        if (e.previousValue != null) {
          alert('Bij het veranderen van de onderaannemer zal de bijhoren beoordeling verwijderd worden.');
        }
        this.subContractorValueChanged = true;
      },
    };
  }

  get rawmaterialsColumns() {
    return [
      {
        dataField: 'name',
        caption: 'Naam',
      },
      {
        caption: 'Aantal',
        calculateDisplayValue: (e: any) => {
          const amount = Math.round(e.amount * 100) / 100;
          return amount + ' ' + e.measuringUnit;
        },
      },
      {
        dataField: 'unitPrice',
        caption: 'Eenheidsprijs',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
      {
        dataField: 'totalPrice',
        caption: 'Totaal',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
      },
    ];
  }

  get totalRawmaterials() {
    let total: number = 0;

    if (this.rawmaterials) {
      this.rawmaterials.forEach((rawmaterial: any) => {
        total += rawmaterial.totalPrice;
      });
    }

    return Math.round(total * 100) / 100;
  }

  get sources(): any[] {
    const results: any[] = [];

    if (this.measuringState && this.measuringState.quotationIds) {
      this.measuringState.quotationIds.forEach((quotationId: string) => {
        const quotation = (this.quotations as any[]).find((o) => o.id === quotationId);
        if (quotation) {
          results.push(quotation);
        }
      });
    }

    return results;
  }

  get executionMonthOptions() {
    const months = this.uniqueMonths;

    return {
      dataSource: months,
      valueExpr: 'value',
      displayExpr: 'text',
      showClearButton: true,
    };
  }

  @Watch('navIndex')
  onNavIndexChanged(value: number, oldValue: number) {
    if (value === -1 && oldValue !== -1) {
      value = oldValue;
    }

    if (value !== -1 && value !== oldValue) {
      this.$router.replace({
        query: { navIndex: '' + value },
      });
    } else {
      this.setNav();
    }
  }

  @Watch('monthForm.selectedMonth')
  async onMonthChanged(value: moment.Moment, oldValue: moment.Moment) {
    this.selectedMonth = value;

    await this.loadMeasuringState(value);
  }
}
